var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Event = function () {

  /**
   * Create a new Event instance.
   *
   */
  function Event() {
    _classCallCheck(this, Event);

    this.vue = new Vue();
  }

  /**
   * Fires an event on vue instance.
   * 
   * @param {string} event name
   * @param {object} data 
   */


  _createClass(Event, [{
    key: "fire",
    value: function fire(event) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;


      this.vue.$emit(event, data);
    }

    /**
     * Registeres an event handler
     * 
     * @param {string} event name
     * @param {function} callback Event handler
     */

  }, {
    key: "listen",
    value: function listen(event, callback) {

      this.vue.$on(event, callback);
    }

    /**
     * Registeres an event handler
     * 
     * @param {string} event name
     * @param {function} callback Event handler
     */

  }, {
    key: "once",
    value: function once(event, callback) {

      this.vue.$once(event, callback);
    }
  }]);

  return Event;
}();

export default Event;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/core/event.js
// module id = SMSo
// module chunks = 4